import React from "react";

// @material-ui/core
// core components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import PodTable from "components/Table/PodTable";

export default function Pod() {
  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox>
            <PodTable/>
          </MDBox>
        </Grid>
      </Grid>
    </div>
  );
}
